import React from "react";
import { useState } from "react";
import NavBar from "./NavBar/NavBar";
import SiteNavigation from "./navigation/SiteNavigation";
import Blog from "./Content/Blog/Blog";
import Welcome from "./Content/Welcome/Welcome";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
} from 'react-router-dom';
import { useEffect } from "react";
import { firebaseHandler } from "../firebase/firebaseHandler";
import BlogPost from "./Content/Blog/BlogPost/BlogPost";
import CreatePost from "./Content/Create/CreatePost";
export interface pageLinks {
  welcomePage: () => void;
  aboutPage: () => void;
  blogPage: () => void;
  toolsPage: () => void;
  articlesPage: () => void;
  newPostPage: () => void;
  blogPostPage: () => void;
}

export interface onWhichPage {
    welcome: boolean,
    about: boolean,
    blog: boolean,
    tools: boolean,
    articles: boolean,
}

export interface blogData {
  id: number;
  title: string;
  content: string;
  summary: string;
  like?: number;
}

export interface BlogSummaries {
  date: string;
  data: blogData
}

const emptyContents: any = []
const pages = {
    welcome: false,
    about: false,
    blog: false,
    tools: false,
    articles: false,
    newPost: false,
    blogPost: false
}

const App = () => {
  const [whichPage, setWhichPage] = useState({...pages, welcome: true})
  const [contents, setContents] = useState(emptyContents)
  const [loading, setLoading] = useState(true)
  const [currentBlogName, setCurrentBlogName] = useState('')
  const pageLinks: pageLinks = {
    welcomePage: () => {
      setWhichPage({...pages, welcome: true})
    },
    aboutPage: () => {
      setWhichPage({...pages, about: true})
    },
    blogPage: () => {
      setWhichPage({...pages, blog: true})
    },
    toolsPage: () => {
      setWhichPage({...pages, tools: true})
    },
    articlesPage: () => {
      setWhichPage({...pages, articles: true})
    },
    newPostPage: () => {
      setWhichPage({...pages, newPost: true})
    },
    blogPostPage: () => {
      setWhichPage({...pages, blogPost: true})
    },
  }

  const setWhichPageChild = (page: string) => {
    switch(page) {
      case 'welcome':
        setWhichPage({...pages, welcome: true})
        break;
      case 'about':
        setWhichPage({...pages, about: true})
        break;
      case 'blog':
        setWhichPage({...pages, blog: true})
        break;
      case 'tools':
        setWhichPage({...pages, tools: true})
        break;
      case 'articles':
        setWhichPage({...pages, articles: true})
        break;
      case 'newPost':
        setWhichPage({...pages, newPost: true})
        break;
    }
  }
  
   //@ts-ignore
   useEffect(() => {
    let content = firebaseHandler.getBlogData()
    content.then(content => {
        setContents(content)
        setLoading(false) 
    })
    .catch(e => {
        alert(`Could not grab data due to following error: ${e}`)
    })

}, [])

// window offset Y direction
const [offset, setOffset] = useState(0);
useEffect(() => {

  // when scrolling down or up, set the state and the local storage offset values

  window.onscroll = () => {
    localStorage.offSet = window.pageYOffset;
    setOffset(window.pageYOffset)
  }

  // on load, check the offset of the page from local storage, and load that offset

  window.onload = () => {
    if(localStorage.offSet > 0) setOffset(localStorage.offSet);
  }
});
  return (
    <Router>
      <div className={'all-wrapper'}>
        <header style={{opacity: (100-(offset*2))}}> 
          <NavBar 
          pageLinks={pageLinks}
          whichPage={whichPage}
          setWhichPageChild={setWhichPageChild}
          imgClass={offset > 50 ? 'image-hidden' : ''}
          />
        </header>
        <div className={"page-wrapper"}>
          {/* <SiteNavigation 
          siteLocation={siteLocation}
          status={status}
          pageLinks={pageLinks}
          whichPage={whichPage}
          /> */}
          <Switch>
            <Route exact path={'/'}>
              <Welcome
              contents={contents}
              loading={loading}
              setCurrentBlogName={setCurrentBlogName}
              navigateToPost={pageLinks.blogPostPage}
              setWhichPageChild={setWhichPageChild}
              />
            </Route>
            <Route path={'/blog'}>
              <Blog 
              contents={contents}
              loading={loading}
              setCurrentBlogName={setCurrentBlogName}
              navigateToPost={pageLinks.blogPostPage}
              setWhichPageChild={setWhichPageChild}
              />
            </Route>
            <Route path={'/post'}>
              <BlogPost 
              loading={loading}
              contents={contents}
              setWhichPageChild={setWhichPageChild}
              />
            </Route>
            <Route path={'/create'}>
              <CreatePost 
              setWhichPageChild={setWhichPageChild}
              contents={contents}
              setContents={setContents}
              />
            </Route>
          </Switch>
          <footer></footer>
        </div>
      </div>
    </Router>
  );
}

export default App;










